import type { ReactNode } from "react";

interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  action?: ReactNode;
}

export default function EmptyState({
  icon,
  title,
  description,
  action
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-700 bg-background-900/60 px-6 py-16 text-center animate-fade-in">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-800 text-accent-400">
        <i className={`${icon} text-3xl`} aria-hidden="true" />
      </span>
      <h3 className="mt-5 font-heading text-lg font-600 text-foreground-100">
        {title}
      </h3>
      <p className="mt-2 max-w-md text-sm text-foreground-400">{description}</p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}